import React from 'react';
const OwnOrderContext = React.createContext();
OwnOrderContext.displayName = 'OwnOrderContext';
export default OwnOrderContext;
